<template lang="pug">
  .w-100.mh-100.h-100
    dx-data-grid(ref="grid"
    :data-source='!reportData.IsSummary ? reportData.Data.Data.Rows : reportSummary'
    :selection="{ mode: 'single' }"
    :show-borders='true'
    :style="{ height: localHeight, width: localWidth }"
    :columns="reportData.IsSummary ? fieldsSummary : fields"
    :summary="summary"
    :row-alternation-enabled="true"
    :allow-column-reordering="true"
    :allow-column-dragging="false"
    @content-ready="onContentReady")
      dx-scrolling(mode='virtual', :useNative="false")
      dx-sorting(mode="multiple")
      dx-load-panel(:enabled="true")
      dx-header-filter(:visible="true")
      dx-grouping(:auto-expand-all="reportData.IsSummary")
</template>
<script>
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';

export default {
  name: 'SeparateMileage',
  components: {
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fields: [{
        dataField: 'RowNum',
        caption: '№',
        fixed: true,
        width: 50,
      }, {
        dataField: 'Date',
        caption: 'Дата',
        alignment: 'center',
        customizeText: params => new Date(params.value * 1000).toLocaleDateString('ru', { timeZone: 'UTC' }),
        width: 90,
      }, {
        dataField: 'MileageKm',
        caption: 'Пробег, км',
      }, {
        dataField: 'WorkTimeMileageKm',
        caption: 'Пробег рабочий, км',
      }, {
        dataField: 'OutWorkTimeMileageKm',
        caption: 'Пробег нерабочий, км',
        alignment: 'center',
      }],
      fieldsSummary: [{
        dataField: 'RowNum',
        caption: '№',
        fixed: true,
        width: 50,
      }, {
        dataField: 'ObjectName',
        caption: 'Объект',
      }, {
        dataField: 'SumMileageKm',
        caption: 'Пробег, км',
      }, {
        dataField: 'SumWorkTimeMileageKm',
        caption: 'Пробег рабочий, км',
      }, {
        dataField: 'SumOutWorkTimeMileageKm',
        caption: 'Пробег нерабочий, км',
        alignment: 'center',
      }],
      summaryColoumn: [{
        column: 'RowNum',
        displayFormat: 'Итого:',
      }, {
        column: 'MileageKm',
        name: 'MileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'WorkTimeMileageKm',
        name: 'WorkTimeMileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'OutWorkTimeMileageKm',
        name: 'OutWorkTimeMileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'SumMileageKm',
        name: 'MileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'SumWorkTimeMileageKm',
        name: 'WorkTimeMileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'SumOutWorkTimeMileageKm',
        name: 'OutWorkTimeMileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }],
      reportSummary: [],
      sortableField: null,
      summary: null,
    };
  },
  watch: {
    reportData (value) {
      if (this.reportData.IsSummary) {
        this.convertSummaryData(this.reportData);
      }
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
  },
  mounted () {
    if (this.reportData.IsSummary) {
      this.convertSummaryData(this.reportData);
    }
    this.getSummary();
  },
  methods: {
    convertSummaryData (data) {
      this.reportSummary = data.Data.Data.map((x, i) => ({ ...x, RowNum: i + 1 }));
    },

    getSummary () {
      this.summary = {
        calculateCustomSummary: (options) => {
          if (options.summaryProcess === 'finalize') {
            const value = options;
            const totalValue = this.reportData.IsSummary ? this.reportData.Data[`Sum${options.name}`] : this.reportData.Data.Data[`Sum${options.name}`];
            if (totalValue !== undefined) {
              value.totalValue = totalValue;
            }
          }
        },
        totalItems: this.summaryColoumn,
      };
    },
  },
};
</script>
